import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { requests as seedRequests, type CitizenRequest } from '../data/demandes';
interface RequestsContextValue {
  requests: CitizenRequest[];
  /** Ajoute une requête en tête de liste, sans doublon d'identifiant. */
  addRequest: (request: CitizenRequest) => void;
}
const RequestsContext = createContext<RequestsContextValue>({
  requests: seedRequests,
  addRequest: () => {}
});
export function RequestsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [requests, setRequests] = useState<CitizenRequest[]>(seedRequests);
  const addRequest = useCallback((request: CitizenRequest) => {
    setRequests(current => current.some(item => item.id === request.id) ? current : [request, ...current]);
  }, []);
  const value = useMemo(() => ({
    requests,
    addRequest
  }), [requests, addRequest]);
  return <RequestsContext.Provider value={value} data-id="element-1950" data-mp="rgegujrewex1">{children}</RequestsContext.Provider>;
}
export function useRequests(): RequestsContextValue {
  return useContext(RequestsContext);
}